import * as navigation from 'Navigation';

export default class ConnectionDetailsTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Metadata',
      closeable: false,
      preferenceKey: 'connection-details',
    };
  }
}
